
import { Component, Mixins } from "vue-property-decorator";
import mixin from "./mixin";
import * as modals from "@/lib/modals";
import draggable from "vuedraggable";
import { getModule } from "vuex-module-decorators";
import { OrderModule } from "@/store/modules";
import FacilitySelect from "@/components/form/FacilitySelect.vue";
import notifications from "@/lib/notifications";

@Component({
    name: modals.documentUploadModal,
    components: { draggable }
})
export default class DocumentUploadModal extends  Mixins(mixin) {
    uploadRegionDefaultText : string = "Drag one or more files to attach to this order. Or click here to select files.";
    uploadRegionText : string = "Drag one or more files to attach to this order. Or click here to select files.";
    
    files: File[] = [];
    orderModule: OrderModule = getModule(OrderModule);
    isSaving: boolean = false;
    facilityCode: string = null;

    load () {
        this.files.splice(0, this.files.length);
        this.facilityCode = null;
        this.isSaving = false;
    }

    unload () {
        this.files.splice(0, this.files.length);
    }

    dragOverHandler (event: any) {
        event.preventDefault();

        if (event.dataTransfer.items.length > 0 && event.dataTransfer.items[0].kind == 'file') {
            event.dataTransfer.dropEffect = 'copy';
            this.uploadRegionText = `Drop ${event.dataTransfer.items.length} file(s) to attach to this order.`;
        } else {
            event.dataTransfer.dropEffect = 'none';
        }
    }

    dragLeaveHandler (event: any) {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'none';
        this.uploadRegionText = this.uploadRegionDefaultText;
    }

    dropHandler (event: any) {
        event.preventDefault();
        this.uploadRegionText = this.uploadRegionDefaultText;

        if (event.dataTransfer.items) {

            [...event.dataTransfer.items].forEach((item,i) => {
                if (item.kind === 'file') {
                    const file = item.getAsFile();
                    this.files.push(file);
                }
            });
        }
    }

    clickHandler (event: any) {
        let fileElem = this.$refs['fileInput'] as HTMLInputElement;
        fileElem.click();
    }

    removeFile(index: number) {
        this.files.splice(index, 1);
    }
    
    cancel() {
        this.hideModal();
    }

    getSaveText() : string {
        if (this.files.length == 1) return "Upload 1 File";
        if (this.files.length > 1) return `Upload ${this.files.length} Files`;
        return "Upload";
    }

    async saveDocumentsAsync() {
        this.isSaving = true;
        const request = {
            mountId: 1,
            facilityCode : this.facilityCode,
            files: this.files
        };

        const response = await this.orderModule.addDocumentBatch(request);

        if (response.successful) {
            notifications.success("Upload Complete", "Files have been uploaded successfully.");
            this.hideModal();
        } else {
            notifications.error("Unable to upload", "Error uploading files. Please try again.");
        }

        this.isSaving = false;
    }

    inputChange (event:any) {
        if (event.target.files) {
            [...event.target.files].forEach((file,i) => {
                this.files.push(file);
            });
        }
    }
}

